module.exports = __webpack_public_path__ + "img/onesys-logo.51e39129.png";